import { registerBlockType } from '@wordpress/blocks'; 
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { InspectorControls, AlignmentToolbar, PanelColorSettings, BlockControls, useBlockProps, __experimentalLinkControl as LinkControl, InnerBlocks } from '@wordpress/block-editor';
import {  PanelBody, SelectControl, RangeControl,  TabPanel,  __experimentalBoxControl as BoxControl, ToggleControl, TextControl,  __experimentalBorderBoxControl as BorderBoxControl, __experimentalUnitControl as UnitControl, BaseControl, __experimentalInputControl as InputControl, TextareaControl } from "@wordpress/components";
import {socialIcons} from './lib/socialicons';
import FontIconPicker from '@fonticonpicker/react-fonticonpicker';
import { colors } from './lib/colors';
const ALLOWED_BLOCKS= ['spice-block/spice-social-icon'];

const IconBlock = (props) => {

    const { attributes, setAttributes,clientId } = props;

    setAttributes({ uniqueid: 'icon-id' +clientId.slice(0,8) });

    const { uniqueid, link, icon, hideIcon, iconMargin, iconColor,  iconWidth,  shadowColor, paddings, iconhColor, borderradius, hshadow, vshadow, blurshadow, hidedesktop, hidemobile, hidetablet, animation, durations,  delay, border, iconBg, iconhBg, bordertopradius, borderrightradius, borderbottomradius, borderleftradius, linktarget, textAlignment, addclass, customcss} = attributes;

    const blockProps = useBlockProps();

    const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
	const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
	const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
	const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;
		
	const animationclass='wow animated '+attributes.durations+' '+attributes.animation;

	const displaydesktop=(hidedesktop != true) ? 'hide-desktop' : '';
	const displaytablet=(hidetablet != true) ?   'hide-tablet' : '';
	const displaymobile=(hidemobile != true) ?   'hide-mobile' : '';
	const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;

    const IconSocial = 'icon-socials';

    function setIconColor(value){
        setAttributes({iconColor :value})
    }	
    function setIconBgColor(value){
        setAttributes({iconBg :value})
    }	
    function setShadowColor(value){
        setAttributes({shadowColor :value})
    }	
    function seticonhColor(value){
        setAttributes({iconhColor :value})
    }	
    function setIconhBgColor(value){
        setAttributes({iconhBg :value})
    }	
    const SpiceColorTabPanel = () => (
		<TabPanel
			className="color-tab-panel"
			activeClass="active-tab"
			tabs={[
				{
					name: __('normal', 'spice-blocks'),
					title: __('Normal', 'spice-blocks'),
					className: 'tab-one',
					content:<PanelColorSettings  initialOpen={open}
						
						colorSettings={[
							{	
								value: iconColor,
								onChange: setIconColor,
                                clearable: true,
								label: __('Icon Color:','spice-blocks'),
								
							},
                            {	
								value: iconBg,
								onChange: setIconBgColor,
                                clearable: true,
								label: __('Icon Background Color:','spice-blocks'),
								
							},
						]}
						className={'spice-blocks-normal-button'}
					/>
				},
				{
					name: __('hover', 'spice-blocks'),
					title: __('Hover', 'spice-blocks'),
					className: 'tab-two',
					content:<PanelColorSettings  initialOpen={open}
						
						colorSettings={[
							{	
								value: iconhColor,
								onChange: seticonhColor,
                                clearable: true,
								label: __('Icon Color:','spice-blocks'),
								
							},
                            {	
								value: iconhBg,
								onChange: setIconhBgColor,
                                clearable: true,
								label: __('Icon Background Color:','spice-blocks'),
								
							},
						]}
						className={'spice-blocks-hover-button'}
					/>
				},
			]}
		>
		{ ( tab ) => <p>{ tab.content }</p> }
		</TabPanel>
	);

	var urlfontawesome=plugin.pluginpath+'assets/js/fontawesome.js';
	let linkfontawesome = document.createElement('script');
	linkfontawesome.src=urlfontawesome;
	jQuery('iframe').contents().find('head').append(linkfontawesome);
	   
    return (
        <Fragment>
            <style dangerouslySetInnerHTML={{
				__html: [
				`.icon-socials#${uniqueid} a i{
				    font-size: ${iconWidth + 'px'};
				    color: ${iconColor};
				    border: ${border.width} ${border.style} ${border.color};
				    border-top:${bordertop};
					border-right:${borderright};
					border-bottom:${borderbottom};
					border-left:${borderleft};
					border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};		
				    box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
				    padding: ${paddings.top} ${paddings.left} ${paddings.bottom} ${paddings.right};
				    background-color:${iconBg};
				}
				.icon-socials#${uniqueid} a i:hover{
				    color: ${iconhColor};
				    background-color:${iconhBg};
				}
				.icon-socials#${uniqueid} a{
				   margin: ${iconMargin.top} ${iconMargin.right} ${iconMargin.bottom} ${iconMargin.left};
				}
				.icon-socials#${uniqueid}{
					justify-content: ${textAlignment};
				}
				${customcss}`
				].join('\n')
            }}>
            </style>

            <InspectorControls>
                <PanelBody initialOpen={false} title={__('General Settings','spice-blocks')}>
                    <Fragment>
						<p><strong>{__('Select Icon', 'spice-blocks')}</strong></p>
                        <FontIconPicker
                            theme={"default spicegsicon "+uniqueid}																		
                            icons={socialIcons}
                            value={icon}
                            onChange={(val) => setAttributes({ icon: val })}
                        />
                        <RangeControl 
                            label={__('Width(PX)','spice-blocks')}
                            value={iconWidth}
                            onChange={(newtext) => setAttributes({ iconWidth: newtext })}
                            min={0}
                            max={100}

	                    />
                        <BorderBoxControl
                            colors={colors}
                            label={ __( 'Border' ,'spice-blocks') }
                            value={ border }
                            onChange={(newtext) => setAttributes({ border: newtext })}
                            
                        />
                        <BaseControl className="spice-blocks-border-radius" label={__('Border Radius','spice-blocks')} __nextHasNoMarginBottom={ true }>
					        <UnitControl className={"border-radius-top"} onChange={ (newtext) => setAttributes({ bordertopradius: newtext }) } value={ bordertopradius } placeholder={"Top"} />

					        <UnitControl className={"border-radius-right"} onChange={ (newtext) => setAttributes({ borderrightradius: newtext }) } value={ borderrightradius } placeholder={"right"} />			        
					        
					        <UnitControl className={"border-radius-left"} onChange={ (newtext) => setAttributes({ borderleftradius: newtext }) } value={ borderleftradius } placeholder={"left"}/>

					        <UnitControl className={"border-radius-bottom"}  onChange={ (newtext) => setAttributes({ borderbottomradius: newtext }) } value={ borderbottomradius }  placeholder={"bottom"}/>	       
				        </BaseControl>
                        <TextControl
                            id={attributes.uniqueid}
                            label={__('Link','spice-blocks')}			    
                            value={ attributes.link}
                            onChange={(newtext) => setAttributes({ link: newtext })}
                        />
                        <ToggleControl
							label={__('Open in new Tab','spice-blocks')}
							checked={linktarget}
							onChange={(newtext) => setAttributes({ linktarget: newtext })}
						/>
                        <BoxControl 
                            label={__('Icon Margin','spice-blocks')}
                            values={iconMargin}
                            sides={['top', 'bottom','left','right']}
                            allowReset={false}
                            units={[]}
                            onChange={(newValue) =>
                                setAttributes({
                                    ...iconMargin,
                                    iconMargin: {
                                        top: newValue.top,
                                        left: newValue.left,
                                        right: newValue.right,
                                        bottom: newValue.bottom,
                                    },
                                })
                            }
                        />
                        <BoxControl
                            values={paddings}
                            label={__('Padding','spice-blocks')}
                            units={[]}
                            allowReset={false}
                            onChange={(newValue) =>
                                setAttributes({
                                    ...paddings,
                                    paddings: {
                                        top: newValue.top,
                                        left: newValue.left,
                                        right: newValue.right,
                                        bottom: newValue.bottom,
                                    },
                                })
                            }
                        />
						<PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit'}>					
							<ToggleControl
								label={__('Enable/Disable on Desktop','spice-blocks')}
								checked={hidedesktop}
								onChange={(newval) => setAttributes({ hidedesktop: newval })}
							/>
							<ToggleControl
								label={__('Enable/Disable on Tablet','spice-blocks')}
								checked={hidetablet}
								onChange={(newval) => setAttributes({ hidetablet: newval })}
							/>
							<ToggleControl
								label={__('Enable/Disable on Mobile','spice-blocks')}
								checked={hidemobile}
								onChange={(newval) => setAttributes({ hidemobile: newval })}
							/>
						</PanelBody>
                        <PanelBody initialOpen={false} title={__('Animation Effects','spice-blocks')} className={'spice-panel-edit'}>
	                        <SelectControl
	                            label={__('Animation','spice-blocks')}
	                            value={ animation }
	                            options={ [
	                                { label: __('None','spice-blocks'), value: '' },
	                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
	                                { label: __('Flash','spice-blocks'), value: 'flash' },
	                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
	                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
	                                { label: __('Shake','spice-blocks'), value: 'shake' },
	                                { label: __('Swing','spice-blocks'), value: 'swing' },
	                                { label: __('Tada','spice-blocks'), value: 'tada' },
	                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
	                                { label: __('Jello','spice-blocks'), value: 'jello' },
	                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
	                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
	                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
	                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
	                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
	                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
	                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
	                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
	                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
	                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
	                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
	                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
	                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
	                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
	                                { label: __('Flip','spice-blocks'), value: 'flip' },
	                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
	                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
	                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
	                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
	                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
	                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
	                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
	                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
	                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
	                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
	                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
	                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
	                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
	                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
	                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
	                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
	                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
	                            ] }
	                            onChange={ (newtext) => setAttributes({ animation: newtext }) }					  
	                        />  
	                        { animation != '' && (
	                            <>
	                                <SelectControl
	                                    label={__('Durations','spice-blocks')}
	                                    value={ durations }
	                                    options={ [
	                                        { label: __('Normal','spice-blocks'), value: ' ' },
	                                        { label: __('Slow','spice-blocks'), value: 'slow' },
	                                        { label: __('Fast','spice-blocks'), value: 'fast' },
	                                    ] }
	                                    onChange={ (newtext) => setAttributes({ durations: newtext }) }                   
	                                />  
	                                <TextControl
	                                    label={__('Delay(ms)','spice-blocks')}              
	                                    value={delay}
	                                    onChange={(newtext) => setAttributes({ delay: newtext })}
	                                />
	                            </>
	                        )}
	                    </PanelBody>
                    </Fragment>
                </PanelBody>
                <PanelBody initialOpen={false} title={ __('Box Shadow','spice-blocks') }>   
                    <RangeControl 
                        label={ __('Horizontal Shadow(px)','spice-blocks') }                
                        value={ hshadow}
                        onChange={(newtext) => setAttributes({ hshadow: newtext })}
                        min={0}
                        max={100}
                    />
                    <RangeControl 
                        label={ __('Vertical Shadow(px)','spice-blocks') }              
                        value={ vshadow}
                        onChange={(newtext) => setAttributes({ vshadow: newtext })}
                        min={0}
                        max={100}
                    />  
                    <RangeControl 
                        label={ __('Blur Shadow(px)','spice-blocks') }              
                        value={ blurshadow}
                        onChange={(newtext) => setAttributes({ blurshadow: newtext })}
                        min={0}
                        max={100}
                    />
                    <PanelColorSettings  initialOpen={true}
                        className='spice-block-section-bg-color'
                        title={ __('Box Shadow Color','spice-blocks') }
                        colorSettings={[
                            {
                            value: shadowColor,
                            onChange: setShadowColor,
							clearable:true,
                            label: __('Box Shadow:','spice-blocks')
                            },
                        ]}
                    />
                </PanelBody>
                <PanelBody initialOpen={false} title={__('Color & Background Settings','spice-blocks')} className={"spice-blocks-dual-color"} >
			    	<div {...blockProps} >
						{SpiceColorTabPanel()}
					</div>				   
				</PanelBody>
				<PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
                    <InputControl
                        label={__('Additional Class','spice-blocks')}
                        value={ addclass }
                        onChange={ (userVal)=> setAttributes({addclass:userVal}) }
                    />
                    <TextareaControl
                        label={__('Custom CSS','spice-blocks')}
                        value={ customcss }
                        onChange={ (userVal)=> setAttributes({customcss:userVal}) }
                    />
                </PanelBody>
            </InspectorControls>

            <BlockControls>
				<AlignmentToolbar
					value={textAlignment}
					onChange={(newalign) => setAttributes({ textAlignment: newalign })}
				/>			
			</BlockControls>
            
			<div className={`${IconSocial} ${animationclass} ${addclass}`} id={uniqueid} 
				style={{ animationDelay: delay+ 'ms'}}>
				<a className={displayclass}>
                    <i className={icon} ></i>
                </a> 
			</div>
            
			
        </Fragment>
    )
}

registerBlockType('spice-block/spice-social-icon',{
    title:__('Social Icon','spice-blocks'),
    icon:<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><ellipse ry="3" rx="3.1875" id="svg_1" cy="4.3416" cx="12.56799" stroke="#09A223" fill="#09A223"/><ellipse ry="3" rx="3.1875" id="svg_4" cy="17.09158" cx="4.1305" stroke="#09A223" fill="#09A223"/><ellipse ry="3" rx="3.1875" id="svg_5" cy="17.09158" cx="20.31798" stroke="#09A223" fill="#09A223"/><rect transform="rotate(-32.3881 16.7555 9.09159)" id="svg_6" height="7.24999" width="2.375" y="5.4666" x="15.56799" stroke="#09A223" fill="#09A223"/><rect transform="rotate(33.8254 7.25511 11.5463)" stroke="#09A223" id="svg_9" height="6.9389" width="2.375" y="8.0769" x="6.06761" fill="#09A223"/><rect transform="rotate(90 13.443 17.4041)" stroke="#09A223" id="svg_10" height="7" width="2.375" y="13.90409" x="12.25549" fill="#09A223"/></svg>,
    category:'spice-blocks',
    parent:['spice-blocks/spice-socials'],
    example: {
        'attributes' : {
            'mode' : 'preview',
        }
    },
    keywords:['Social Icon','Spice', 'Icon'],
    supports: {
    html: false,
    anchor: true,
    align: ['wide', 'full']
    },
    attributes:{
        uniqueid:{
            type:'string'
        },
        icon:{
            type:'string',
            default:'fa-brands fa-instagram'
        },
        iconWidth:{
            type:'number',
            default:20
        },
        iconColor:{
            type:'string',
            default:'#fff'
        },
        iconhColor:{
            type:'string'
        },
        iconBg:{
            type:'string',
        	default:'#888'
        },
        iconhBg:{
            type:'string'
        },
        iconMargin:{
            default: {
                top: '0px',
                left: '8px',
                right: '8px',
                bottom: '0px'
            }
        },
        link:{
            type:'string',
            default:''
        },
        linktarget:{
        	type:'boolean',
        	default:true,
        },
		textAlignment: {
			type: 'string',
			default:'left'
		},
        bordertopradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderrightradius:{
	    	type: 'string', 
	    	default: '0px' 
	    },
	    borderbottomradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderleftradius:{
	    	type: 'string',
	    	default: '0px'
	    },
        border: {
            type: 'object',
            default: {
                color: '',
                style: '',
                width: '',        
            },
        },
		paddings:{
			type: 'object',
		    default: {
		        top: '10px',
		        left: '10px',
		        right: '10px',
		        bottom: '10px',
		      },
		},
    	hshadow: {
			type: 'number',
			default:0
		},
		vshadow: {
			type: 'number',
			default:0
		},
		blurshadow: {
			type: 'number',
			default:0
		},
		hidedesktop:{
	    	type: 'boolean',
			default: true
	    },
	    hidetablet:{
	    	type: 'boolean',
			default: true
	    },
	    hidemobile:{
	    	type: 'boolean',
			default: true
	    },
		animation:{
	    	type:'string',
	    	default:'None'
	    },
	    durations:{
	    	type:'string',
	    },
	    delay:{
	    	type:'string',
	    },
	    shadowColor:{
	    	type:'string',
	    	default:'#000'
	    },
	    addclass:{
	    	type:'string',
	    },
	    customcss:{
	    	type:'string',
	    }
    },
    edit: IconBlock,
    save: (props) => {
        const { attributes } = props;

        const { uniqueid, link, icon, hideIcon, iconMargin, iconColor,  iconWidth,  shadowColor, paddings, iconhColor, borderradius, hshadow, vshadow, blurshadow, hidedesktop, hidemobile, hidetablet, animation, durations,  delay, border, iconhBg, iconBg, bordertopradius, borderrightradius, borderbottomradius, borderleftradius, linktarget, textAlignment, addclass, customcss} = attributes;

        const animationclass='wow animated '+attributes.durations+' '+attributes.animation;

        const displaydesktop=(hidedesktop != true) ? 'hide-desktop' : '';
        const displaytablet=(hidetablet != true) ? 'hide-tablet' : '';
        const displaymobile=(hidemobile != true) ? 'hide-mobile' : '';
        const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;

        const IconSocial = 'icon-socials';

        const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
		const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
		const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
		const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;
		
		const openinnew=(linktarget == true)?'_blank':'_self';
		
        return (
            <>
                <style dangerouslySetInnerHTML={{
					__html: [
					`.icon-socials#${uniqueid} a i{
					    font-size: ${iconWidth + 'px'};
					    color: ${iconColor};
					    background-color:${iconBg};
					    border: ${border.width} ${border.style} ${border.color};
					    border-top:${bordertop};
						border-right:${borderright};
						border-bottom:${borderbottom};
						border-left:${borderleft};
						border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};	
					    box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
					    padding: ${paddings.top} ${paddings.left} ${paddings.bottom} ${paddings.right};
					}
					.icon-socials#${uniqueid} a i:hover{
					    color: ${iconhColor};
					    background-color:${iconhBg};
					}
					.icon-socials#${uniqueid} a{
					    margin: ${iconMargin.top} ${iconMargin.right} ${iconMargin.bottom} ${iconMargin.left};
					}
					.icon-socials#${uniqueid}{
						justify-content: ${textAlignment};
					}
					${customcss}`
					].join('\n')
            	}}>
                </style>

                <div className={`${IconSocial} ${animationclass} ${displayclass} ${props.attributes.className} ${addclass}`} id={uniqueid}
					style={{ animationDelay: delay+ 'ms',}}>                
                    <a  href={link} target={openinnew} rel="noopener noreferrer">
                        <i className={icon} ></i>
                    </a> 
                </div>            	
            </>
        )
    }    
});